import { useApi } from './use-api-call';

export const useSearchCategoryApi = () =>
    useApi<{
        categories: CategoryDTO[];
        allowEdit: boolean;
    }>('/category/search-category');

export const useGetCategoryApi = () =>
    useApi<{ category: CategoryDTO; allowEdit: boolean }>('/category/get-category/{code}');

export const useSaveCategoryApi = () =>
    useApi<{ category: CategoryDTO }>('/category/save-category');

export const useDeleteCategoryApi = () => useApi('/category/delete-category/{code}');

export interface CategoryDTO {
    code: string;
    title: string;
}
